// src/components/UserCard.js
import React from "react";
import { Card, Button, Collapse, Spinner, Row, Col } from "react-bootstrap";
import { FiUser, FiChevronDown, FiChevronUp } from "react-icons/fi";

const UserCard = ({
  user,
  depth = 0,
  onToggle,
  onReport,
  getRoleDisplayName,
}) => {
  const hasSubordinates = user.role !== "relationship_manager";
  const wrapperClass =
    depth > 0 ? "user-card-wrapper subordinate" : "user-card-wrapper";

  return (
    <div className={wrapperClass} style={{ "--depth": depth }}>
      <Card className="user-card">
        <Card.Body>
          <Row className="align-items-center">
            {/* User Info Section */}
            <Col md={4} className="d-flex align-items-center">
              <div className="user-avatar me-3">
                <FiUser size={20} />
              </div>
              <div>
                <h6 className="mb-0 fw-bold">{user.name}</h6>
                <p className="text-muted small mb-0">@{user.username}</p>
              </div>
            </Col>

            {/* Details Section */}
            <Col md={3}>
              <p className="small mb-1">
                <strong>Role:</strong> {getRoleDisplayName(user.role, true)}
              </p>
              <p className="small mb-0">
                <strong>Location:</strong> {user.location || "N/A"}
              </p>
            </Col>

            {/* Actions Section */}
            <Col
              md={5}
              className="d-flex justify-content-end align-items-center gap-2"
            >
              {hasSubordinates && (
                <Button
                  className="gradient-btn"
                  size="sm"
                  onClick={() => onToggle(user.user_id)}
                >
                  View Team{" "}
                  {user.isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                </Button>
              )}
              <Button
                variant="link"
                className="text-secondary text-decoration-none"
                size="sm"
                onClick={() => onReport(user.user_id)}
              >
                Monthly Report
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {hasSubordinates && (
        <Collapse in={user.isExpanded}>
          <div className="subordinates-container">
            {user.isLoading ? (
              <div className="loading-state">
                <Spinner animation="border" size="sm" />
              </div>
            ) : user.subordinates && user.subordinates.length > 0 ? (
              user.subordinates.map((sub) => (
                <UserCard
                  key={sub.user_id}
                  user={sub}
                  depth={depth + 1}
                  onToggle={onToggle}
                  onReport={onReport}
                  getRoleDisplayName={getRoleDisplayName}
                />
              ))
            ) : (
              <div className="no-subordinates-message">
                No subordinates found.
              </div>
            )}
          </div>
        </Collapse>
      )}
    </div>
  );
};

export default UserCard;
